export interface Entity {
    logicId: string;
    externalId: string;
    customData?: unknown;
}

export const USER_COUNTRY_KEY = "country_code";

